import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { FeedPost } from './types'

export const CREATE_FEED_POST: TypedDocumentNode<
  { createFeedPost: FeedPost },
  {
    client_id: string
    application_id: string
    title: string
    content?: string | null
    image?: string | null
    published_at?: string | null
  }
> = gql`
  mutation CreateFeedPost(
    $client_id: ID!
    $application_id: ID!
    $title: String!
    $content: String
    $image: String
    $published_at: String
  ) {
    createFeedPost(
      client_id: $client_id
      application_id: $application_id
      title: $title
      content: $content
      image: $image
      published_at: $published_at
    ) {
      id client_id application_id title content image image_low_res published_at created_at updated_at
    }
  }
`

export const UPDATE_FEED_POST: TypedDocumentNode<
  { updateFeedPost: FeedPost },
  {
    id: string
    title?: string
    content?: string | null
    image?: string | null
    published_at?: string | null
  }
> = gql`
  mutation UpdateFeedPost(
    $id: ID!
    $title: String
    $content: String
    $image: String
    $published_at: String
  ) {
    updateFeedPost(
      id: $id
      title: $title
      content: $content
      image: $image
      published_at: $published_at
    ) {
      id client_id application_id title content image image_low_res published_at created_at updated_at
    }
  }
`

export const DELETE_FEED_POST: TypedDocumentNode<{ deleteFeedPost: boolean }, { id: string }> = gql`
  mutation DeleteFeedPost($id: ID!) {
    deleteFeedPost(id: $id)
  }
`
